/**
 * ROM/FBC Field Component
 * Dropdown for BDM (Regional Operations Manager / Franchise Business Coach) filter
 */

import React from 'react'
import { FormControl, Select, MenuItem, Typography, Box, SelectChangeEvent } from '@mui/material'
import { BdmOption } from '../types'

interface RomFbcFieldProps {
  value: string
  onChange: (value: string) => void
  bdmOptions: BdmOption[]
  disabled?: boolean
  loading?: boolean
  label?: string
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const RomFbcField: React.FC<RomFbcFieldProps> = ({
  value,
  onChange,
  bdmOptions,
  disabled = false,
  loading = false,
  label = 'ROM/FBC',
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value)
  }

  return (
    <Box>
      <Typography component="label" sx={labelStyle}>
        {label}
      </Typography>
      <FormControl fullWidth size="small" disabled={disabled || loading}>
        <Select displayEmpty value={value} onChange={handleChange}>
          <MenuItem value="">All</MenuItem>
          {bdmOptions.map((option) => (
            <MenuItem key={option.id} value={option.id.toString()}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default RomFbcField
